import { Enumify } from 'enumify-ts';
class CountryType extends Enumify() {
    description;
    hasStates;
    static AU = new CountryType('Australia', true);
    static NZ = new CountryType('New Zealand', false);
    static _ = CountryType._closeEnum();
    static selectOptionsArray() {
        return CountryType.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
    constructor(description, hasStates) {
        super();
        this.description = description;
        this.hasStates = hasStates;
    }
}
export default CountryType;
